__turbopack_context__.v({
  "campaignLinkButton": "EsV_WW_campaignLinkButton",
  "item": "EsV_WW_item",
  "list": "EsV_WW_list",
  "navigation": "EsV_WW_navigation",
  "wrapper": "EsV_WW_wrapper",
});
